import { Box as MuiBox, TextField as MuiTextField } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { StudyListingPageStyle } from "./StudyListingPageStyle";
import SidebarSectionHeader from "./SidebarSectionHeader";
import { useState } from "react";
import axios from "axios";
import { GET_STUDIES_URL_BASE } from "app/shared/constants";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";

export const StudyInterestSection = ({ studyId, studySurveyUrl }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  const theme = useTheme();
  const styles = StudyListingPageStyle(theme);

  const saveStudyInterest = async (values) => {
    if (!studyId) return;
    setLoading(true);
    try {
      const payload = { surveyUrl: values.studySurveyUrl || null };
      await axios.patch(
        `${GET_STUDIES_URL_BASE}/study-website-content/${studyId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/merge-patch+json",
          },
        },
      );
    } catch (err) {
      console.error("Failed to save study interest settings", err);
    }
    setLoading(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      studySurveyUrl: studySurveyUrl || "",
    },
    validationSchema: Yup.object({
      studySurveyUrl: Yup.string()
        .test("is-valid-url", "Please enter a valid URL", (value) => {
          if (!value || value.trim() === "") return true;
          // Simple URL validation
          try {
            new URL(value);
            return true;
          } catch {
            return false;
          }
        })
        .notRequired(),
    }),
    onSubmit: (values) => {
      saveStudyInterest(values);
    },
  });

  return (
    <MuiBox sx={styles.sideBarSection}>
      <SidebarSectionHeader
        title={t("StudyWebisteContentForm.studyInterest")}
        description={t("StudyWebisteContentForm.studyInterestMessage")}
        loading={loading}
      />

      <MuiTextField
        label={t("StudyWebisteContentForm.prescreenUrl")}
        name="studySurveyUrl"
        value={formik.values.studySurveyUrl}
        onChange={formik.handleChange}
        onBlur={(e) => {
          formik.handleBlur(e);
          formik.submitForm();
        }}
        error={Boolean(
          formik.touched.studySurveyUrl && formik.errors.studySurveyUrl,
        )}
        helperText={
          formik.touched.studySurveyUrl && formik.errors.studySurveyUrl
        }
        variant="outlined"
        margin="normal"
        size="small"
        disabled={loading}
      />
    </MuiBox>
  );
};

StudyInterestSection.propTypes = {
  studyId: PropTypes.number.isRequired,
  studySurveyUrl: PropTypes.string,
};

export default StudyInterestSection;
